// extracted by mini-css-extract-plugin
export default {"notificationAlert":"notification-alert_notificationAlert__ZSdwf","text":"notification-alert_text__kc6jv"};